import * as angular from 'angular';

import { Log, ComponentDefinition } from '../../../models';
import { dateFormat } from '../../../common/constants';

class LogsListController implements angular.IComponentController {
    control: any;
    dateFormat: string;
    selectedLog: Log;
    selectedRowIndex: number;

    readonly isLoading: boolean;
    readonly logs: Log[];

    static $inject = ['$scope'];

    constructor(private _$scope: angular.IScope) {
    }

    $onInit() {
        this.dateFormat = dateFormat;
        this._$scope.$watch(() => this.selectedRowIndex, () => {
            if (this.logs && this.logs.length > 0 && this.selectedRowIndex >= 0) {
                this.selectedLog = this.logs[this.selectedRowIndex];
            } else if (this.logs && this.logs.length === 0 && this.selectedRowIndex) {
                this.selectedLog = undefined;
            }
        });
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['logs']?.currentValue && this.logs.length > 0) {
            this.selectedRowIndex = 0;
        }
    }

    setClickedRow(index: number): void {
        this.selectedRowIndex = index;
    }

    getClass(index: number) {
        let result = {};
        if (this.selectedRowIndex === index) {
            const log = this.logs[index];
            const level = log.level;
            if (level === 'INFO') {
                result = { 'alert alert-success': true };
            } else if (level === 'DEBUG') {
                result = { 'alert alert-info': true };
            } else if (level === 'WARN') {
                result = { 'alert alert-warning': true };
            } else if (level === 'ERROR') {
                result = { 'alert alert-danger': true };
            }
        }

        return result;
    }
}

export const wtLogsList: ComponentDefinition = {
    componentId: 'wtLogsList',
    controller: LogsListController,
    template: require('./LogsList.component.html'),
    controllerAs: 'vm',
    bindings: {
        logs: '<',
        isLoading: '<',
        selectedLog: '=?'
    }
};
